
export default function CTA() {
  return (
    <section className="py-20 bg-gradient-to-r from-[#0069a5] to-purple-700">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Bring Your Ideas to Life?
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            Join hundreds of satisfied customers who have transformed their digital visions 
            into stunning physical models. Start your 3D printing journey today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button className="bg-white text-[#0069a5] hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Browse All Models
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-[#0069a5] px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Custom Order
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
            <div className="space-y-2">
              <div className="w-12 h-12 flex items-center justify-center mx-auto bg-white/20 rounded-full">
                <i className="ri-truck-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Fast Delivery</h3>
              <p className="text-blue-100">Quick turnaround times for all orders</p>
            </div>
            
            <div className="space-y-2">
              <div className="w-12 h-12 flex items-center justify-center mx-auto bg-white/20 rounded-full">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Quality Guarantee</h3>
              <p className="text-blue-100">100% satisfaction or money back</p>
            </div>
            
            <div className="space-y-2">
              <div className="w-12 h-12 flex items-center justify-center mx-auto bg-white/20 rounded-full">
                <i className="ri-customer-service-2-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold">Expert Support</h3>
              <p className="text-blue-100">Professional guidance every step</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
